<template>
  <div :style="styleObject">
    <f7-popup
      class="demo-popup"
      style="display: block;
    width: 500px;
    left: 50%;
    margin-left: -250px;"
      :opened="popupOpened"
      @popup:closed="close"
    >
      <f7-page>
        <f7-navbar title="Shortcut">
          <f7-nav-right>
            <f7-link @click="close">Close</f7-link>
          </f7-nav-right>
        </f7-navbar>
        <f7-block>
          <!-- <div class="select"> -->
          <b-select name="tpl_name" v-model="tplName" style="width:40%">
            <option value="diamond_response">Diamond response</option>
          </b-select>
          <!-- </div> -->
          <!-- <select v-model="tplName" style="display: inline-block;">
            <option value="diamond_response">Diamond response</option>
          </select>-->

          <b-select v-model="tplLangId" style="width:30%;margin-left: 20px;">
            <option value="0">Language</option>
            <option value="1">English</option>
            <option value="2">简体中文</option>
            <option value="3">繁体中文</option>
            <option value="4">泰文</option>
          </b-select>

          <f7-button @click="getTpl" fill style="display: inline-block;margin-left: 20px;">Get</f7-button>

          <hr />
          <div contenteditable="true" v-html="textVal"></div>
          <!-- <textarea v-model="textVal" style="display:none"></textarea> -->
          <hr />
          <div class="text-center">
            <button
              :class="canSend?'':'disabled'"
              @click="sendTpl"
              class="btn btn-ls-g rounded-pill px-5"
            >Send</button>
          </div>
        </f7-block>
      </f7-page>
    </f7-popup>
  </div>
</template>
<script>
export default {
  name: "shortcutPop",
  data() {
    return {
      popupOpened: false,
      textVal: "",
      tplName: "diamond_response",
      canSend: false,
      tplLangId: 1,
      inputData: {},
      styleObject: {
        display: "none",
      },
    };
  },
  methods: {
    sendTpl() {
      let self = this;

      // console.log(self.textVal);
      let text = self.textVal.replace(/<br>/g, "\r\n");
      self.$emit("sendTplText", { tpl_text: text });
    },
    open(data) {
      // console.log("open", data);
      let self = this;
      self.popupOpened = true;
      self.styleObject.display = "block";
      self.inputData = data;
    },
    close() {
      let self = this;
      self.popupOpened = false;
      self.styleObject.display = "none";
      self.textVal = "";
      self.canSend = false;
    },
    getTpl() {
      let self = this;
      self.$layer.loading();
      let clientId = _.get(self.inputData, "from_client_id", 0);
      if (!clientId) {
        clientId = _.get(self.inputData, "to_client_id", 0);
      }
      this.$http
        .get(
          `/api/v2/msgTpl/tpl?tpl_name=${self.tplName}&client_id=${clientId}&lang_id=${self.tplLangId}`
        )
        .then((rs) => {
          self.$layer.closeAll("loading");
          // console.log("msgTpl=", rs);
          if (_.has(rs, "data.message")) {
            let string = _.get(rs, "data.message").replace(/\r\n/g, "<br>");
            string = string.replace(/\n/g, "<br>");
            self.textVal = string;

            self.canSend = true;
          }
        });
    },
  },
};
</script>